<template>
  <div>
    <div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-button size="mini" icon="el-icon-plus" type="success" @click="dialogFormVisible = true">添加</el-button>

      </el-form>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="序号" type="index" width="50"/>
      <el-table-column prop="add_time" width="160" label="创建时间"/>
      <el-table-column prop="name" label="管理员" width="160"/>
      <el-table-column prop="workcode" label="工号" width="150"/>
      <el-table-column prop="show_secrecy" label="查看保密会议" width="120" >
        <template slot-scope="scope">
          <span v-if="scope.row.show_secrecy===1">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="departmentGroup" label="绑定部门">
        <template slot-scope="scope">
          <el-tag v-for="(ud,index) in scope.row.departmentGroup" :key="index" style="margin:0 5px 5px 0">{{ ud.longName }} </el-tag><br>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editBtn(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteBtn(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" title="添加配置">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="管理员" prop="user">
          <el-select
            v-model="form.user"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            clearable
            placeholder="请输入"
            filterable
            remote
            reserve-keyword
            @visible-change="clearSelectList">
            <el-option
              v-for="(item,index) in personInChargeList"
              :label="item.name+'('+item.username+')'"
              :value="item.name+'/'+item.username"
              :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department">
          <el-select
            v-model="form.department"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:90%"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词">
            <el-option
              v-for="item in departmentList"
              :key="item.udId"
              :label="item.longName+' ('+item.ucName+')'"
              :value="item.udId"/>
          </el-select>
        </el-form-item>
        <el-form-item label="保密会议查看" prop="show_secrecy">
          <el-radio-group v-model="form.show_secrecy">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitAdd('form')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="editVisible" title="编辑">
      <el-form ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="管理" prop="user" label-width="120px">
          <el-select
            v-model="editForm.user"
            :remote-method="getUserInfoByName"
            :loading="selectLoading"
            clearable
            placeholder="请输入"
            filterable
            remote
            reserve-keyword
            @visible-change="clearSelectList">
            <el-option
              v-for="(item,index) in personInChargeList"
              :label="item.name+'('+item.username+')'"
              :value="item.name+'/'+item.username"
              :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department" label-width="120px">
          <el-select
            v-model="editForm.department"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:90%"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词">
            <el-option
              v-for="item in departmentList"
              :key="item.udId"
              :label="item.longName+' ('+item.ucName+')'"
              :value="item.udId"/>
          </el-select>
        </el-form-item>
        <el-form-item label="保密会议查看" prop="show_secrecy">
          <el-radio-group v-model="editForm.show_secrecy">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submitEdit('editForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getDepartmentByName, getUserInfoByName, getDepartmentByIds } from '@/api/login'
import { createDepartment, editDepartment, searchDepartment, deleteDepartment } from '@/api/department'

export default {
  data() {
    return {
      dialogFormVisible: false,
      editVisible: false,
      loading: false,
      form: {
        user: '',
        department: '',
        show_secrecy: 0
      },
      editForm: {
        user: '',
        department: '',
        show_secrecy: 0
      },
      searchForm: {},
      departmentList: [],
      personInChargeList: [],
      selectLoading: false,
      rules: {
        user: [
          { required: true, message: '请选择人名', trigger: 'change' }
        ],
        department: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ]
      },
      tableData: []
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    getTableData() {
      searchDepartment().then(res => {
        if (res.code === 'success') {
          const data = res.data.role
          for (const i in data) {
            data[i].departmentGroup = []
            // data[i].department = JSON.parse(data[i].department);
            console.log(data[i].department, '数组')

            // 通过调接口查多个部门
            getDepartmentByIds(data[i].department).then(res2 => {
              if (res2.data) {
                data[i].departmentGroup = res2.data
                this.$forceUpdate()
              }
            }).catch(() => {})

            // 通过单个id查询部门
            // for(let j in data[i].department){
            //   console.log(data[i].department[j],'数组2');
            //   getDepartmentById( data[i].department[j]  ).then(res2=>{
            //       data[i].departmentGroup.push(res2.data);
            //       this.$forceUpdate();
            //   }).catch(err=>{})
            // }
          }
          this.tableData = data
          //  console.log(this.tableData)
        } else {
          this.tableData = []
        }
      }).catch(() => {})
    },
    searchDepartmentBtn(query) {
      const params = {
        longName: query,
        pageNum: 1,
        pageSize: 1000
      }
      getDepartmentByName(params).then(res => {
        if (res.data) {
          this.departmentList = res.data.list
        } else {
          this.departmentList = []
        }
      })
    },
    remoteMethod(query) { // 部门搜索
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.searchDepartmentBtn(query)
        }, 200)
      } else {
        this.options = []
      }
    },
    // 搜索用户
    getUserInfoByName(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          page_size: 10
        }
        getUserInfoByName(params).then(res => {
          this.personInChargeList = res.data.list
          this.selectLoading = false
        })
      }
    },
    // 清空用户
    clearSelectList(val) {
      if (val === false) {
        this.personInChargeList = []
      }
    },
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const arr3 = this.form.user.split('/')

          const query = {
            name: arr3[0],
            workcode: arr3[1],
            department: this.form.department,
            show_secrecy: this.form.show_secrecy
          }

          createDepartment(query).then(res => {
            if (res.code === 'success') {
              this.$message({
                message: '操作成功！',
                type: 'success'
              })
              this.getTableData()
            }
          }).catch(() => {})

          this.dialogFormVisible = false
          this.form = {
            user: '',
            department: ''
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitEdit(formName, id) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const arr3 = this.editForm.user.split('/')
          const query = {
            name: arr3[0],
            workcode: arr3[1],
            department: this.editForm.department,
            show_secrecy: this.editForm.show_secrecy
          }

          editDepartment(this.editForm.id, query).then(res => {
            if (res.code === 'success') {
              this.$message({
                message: '编辑成功！',
                type: 'success'
              })
              this.getTableData()
            }
          }).catch(() => {})

          this.editVisible = false
          this.editForm = {
            user: '',
            department: ''
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editBtn(row) {
      this.editForm.user = row.name + '/' + row.workcode

      this.clearSelectList()
      this.personInChargeList = [{
        name: row.name,
        username: row.workcode
      }]
      this.editForm.id = row.id
      this.editForm.department = row.department
      this.editForm.show_secrecy = row.show_secrecy
      this.departmentList = row.departmentGroup

      this.editVisible = true
    },
    deleteBtn(id) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDepartment(id).then(res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getTableData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
